enum IconTypes {
  accessTime = "accessTime",
  article = "article",
  adminHome = "adminHome",
  analytics = "analytics",
  automation = "automation",
  all = "all",
  arrowDown = "arrowDown",
  arrowLeft = "arrowLeft",
  arrowRight = "arrowRight",
  arrowUp = "arrowUp",
  arrowUpDown = "arrowUpDown",
  appOnly = "app-only",
  audio = "audio",
  billing = "billing",
  bin = "bin",
  bookmark = "bookmark",
  bookmarkFill = "bookmarkFill",
  burgerMenu = "burgerMenu",
  bolt = "bolt",
  businessUnit = "businessUnit",
  calendar = "calendar",
  call = "call",
  capsLockOn = "capsLockOn",
  categories = "categories",
  celebration = "celebration",
  celebrationFill = "celebrationFill",
  rewards = "rewards",
  rewardsFill = "rewardsFill",
  celebrationAnimated = "celebrationAnimated",
  celebrationNexus = "celebrationNexus",
  checklist = "checklist",
  check = "check",
  chevronDown = "chevronDown",
  chevronLeft = "chevronLeft",
  chevronRight = "chevronRight",
  chevronUp = "chevronUp",
  circle = "circle",
  circleAlert = "circleAlert",
  circleAlertFill = "circleAlertFill",
  circleCrossFill = "circleCrossFill",
  circleDisable = "circleDisable",
  circleFastForward = "circleFastForward",
  circleInformation = "circleInformation",
  circlePause = "circlePause",
  circlePlay = "circlePlay",
  circleQuestion = "circleQuestion",
  circleTickFill = "circleTickFill",
  circleCheckFill = "circleCheckFill",
  circleExpand = "circleExpand",
  circleContract = "circleContract",
  circleArrowRight = "circleArrowRight",
  circlePlusFilled = "circlePlusFilled",
  circleMinus = "circleMinus",
  circleCelebration = "circleCelebration",
  circlePerks = "circlePerks",
  circleWellness = "circleWellness",
  circleRewards = "circleRewards",
  circleAdmin = "circleAdmin",
  csvFile = "csvFile",
  pinned = "pinned",
  piggyBank = "piggyBank",
  pound = "pound",
  collapse = "collapse",
  companyBenefit = "companyBenefit",
  copy = "copy",
  countries = "countries",
  mediaCourse = "mediaCourse",
  cross = "cross",
  customisation = "customisation",
  document = "document",
  download = "download",
  downloadReport = "downloadReport",
  deletedFile = "DeletedFile",
  edit = "edit",
  heartHand = "heartHand",
  email = "email",
  expand = "expand",
  export = "export",
  eye = "eye",
  eyeDisabled = "eyeDisabled",
  favourite = "favourite",
  favouriteFill = "favouriteFill",
  funnel = "funnel",
  filter1 = "filter1",
  filter2 = "filter2",
  filter3 = "filter3",
  filterHighToLow = "filterHighToLow",
  filterLowToHigh = "filterLowToHigh",
  filterUpAndDown = "filterUpAndDown",
  flexi = "flexi",
  flexiPoints = "flexiPoints",
  flexiPointsFilled = "flexiPointsFilled",
  generateReport = "generateReport",
  homeFill = "homeFill",
  hourGlass = "hourGlass",
  information = "information",
  instant = "instant",
  integration = "integration",
  label = "label",
  lightBulb = "lightBulb",
  location = "location",
  medical = "medical",
  medicalFill = "medicalFill",
  minus = "minus",
  msTeams = "msTeams",
  notification = "notification",
  notificationBold = "notificationBold",
  notificationFilled = "notificationFilled",
  multiComments = "multiComments",
  multiCommentsFilled = "multiCommentsFilled",
  openTab = "openTab",
  package = "package",
  pending = "pending",
  perksFill = "perksFill",
  personSearch = "personSearch",
  plus = "plus",
  pointer = "pointer",
  pointingHand = "pointingHand",
  profile = "profile",
  results = "results",
  reward = "reward",
  reward2 = "reward2",
  savingsAnimated = "savingsAnimated",
  scissors = "scissors",
  search = "search",
  searchPeople = "searchPeople",
  send = "send",
  settings = "settings",
  shareAnimated = "shareAnimated",
  shareTo = "shareTo",
  singleMedia = "singleMedia",
  speech = "speech",
  speechPlus = "speechPlus",
  signature = "signature",
  star = "star",
  starFill = "starFill",
  survey = "survey",
  tick = "tick",
  thumbsUp = "thumbsUp",
  uploadReport = "uploadReport",
  wallet = "wallet",
  hypnosis = "hypnosis",
  meditation = "meditation",
  sleepStories = "sleepStories",
  talkingTherapy = "talkingTherapy",
  teams = "teams",
  warning = "warning",
  workout = "workout",
  yoga = "yoga",
  liveBanner = "liveBanner",
  webinars = "webinars",
  wellness = "wellness",
  wellnessFill = "wellnessFill",
  rewardPoints = "rewardPoints",
  uploadCSV = "uploadCSV",
  payments = "payments",
  payByCard = "payByCard",
  cultureHub = "cultureHub",
  cultureHubFill = "cultureHubFill",
  homeElectronics = "homeElectronics",
  homeElectronicsFill = "homeElectronicsFill",
  cycleToWork = "cycleToWork",
  cycleToWorkFill = "cycleToWorkFill",
  annualLeavePurchase = "annualLeavePurchase",
  annualLeavePurchaseFill = "annualLeavePurchaseFill",
  externalLink = "externalLink",
  cart = "cart",
  bicycle = "bicycle",
  infoPrimary1 = "infoPrimary1",
  upRightArrow = "upRightArrow",
  spinner = "spinner",
  verifyBusiness = "verifyBusiness",
  verifyIdentity = "verifyIdentity",
  psychiatry = "psychiatry",
  thumbUp = "thumb_up",
  savings = "savings",
  directionsCar = "directions_car",
  exercise = "exercise",
  luggage = "luggage",
  flightTakeOff = "flight_takeoff",
  verified = "verified",
  verifiedUser = "verifiedUser",
  seasonalGift = "featured_seasonal_and_gifts",
  creditCardHeart = "credit_card_heart",
  healthAndSafety = "health_and_safety",
  medicalServices = "medical_services",
  emergency911 = "e911_emergency",
  dentistry = "dentistry",
  rheumatology = "rheumatology",
  homeHealth = "home_health",
  physicalTherapy = "physical_therapy",
  sportsMotorsports = "sports_motorsports",
  addShoppingCart = "add_shopping_cart",
  checkBox = "check_box",
  directionsBike = "directions_bike",
  lock = "lock",
  shield = "shield",
  supportAgent = "supportAgent",
  lockPerson = "lockPerson",
  lockPersonFilled = "lockPersonFilled",
  markChatRead = "markChatRead",
  favouriteBorder = "favouriteBorder",
  shoppingBasket = "shopping_basket",
  undo = "undo",
  currency = "currency",
  arrowPointerSolid = "arrowPointerSolid",
  clipBoardCheckSolid = "clipBoardCheckSolid",
  calenderDaySolid = "calenderDaySolid",

  // === old icons below ===
  addAdmin = "addAdmin",
  addBookmark = "addBookmark",
  addComment = "addComment",
  addEmoji = "addEmoji",
  addReward = "addReward",
  adminHelp = "adminHelp",
  adminLoginIntegrations = "adminLoginIntegrations",
  adminReports = "adminReports",
  adminRolesPermission = "adminRolesPermissions",
  angleLeft = "angleLeft",
  angleRight = "angleRight",
  angleUp = "angleUp",
  angleDown = "angleDown",
  announcement = "announcement",
  apps = "apps",
  archive = "archive",
  attachment = "attachment",
  backArrow = "backArrow",
  blog = "blog",
  circleHollow = "circleHollow",
  circleTick = "circleTick",
  clipboard = "clipboard",
  clock = "clock",
  close = "close",
  comment = "comment",
  customReward = "customReward",
  refresh = "refresh",
  dca = "dca",
  delete = "delete",
  disabledEditQuestion = "disabledEditQuestion",
  dotDotDot = "dotDotDot",
  downArrow = "downArrow",
  downloadFile = "downloadFile",
  duplicate = "duplicate",
  editPencil = "editPencil",
  editQuestion = "editQuestion",
  ellipsis = "ellipsis",
  emoji = "emoji",
  emojiActive = "emojiActive",
  event = "event",
  eyeSlash = "eyeSlash",
  favouriteOutline = "favouriteOutline",
  fileDownload = "fileDownload",
  files = "files",
  filterActive = "filterActive",
  geoArrow = "geoArrow",
  geoPin = "geoPin",
  globe = "globe",
  heartOutline = "heartOutline",
  help = "help",
  home = "home",
  i = "i",
  info = "info",
  landscape = "landscape",
  launch = "launch",
  logoBox = "logoBox",
  logout = "logout",
  menu = "menu",
  mobileSecondaryNav = "mobileSecondaryNav",
  more = "more",
  myPerks = "myPerks",
  myRecognition = "myRecognition",
  magicWand = "magicWand",
  newsletter = "newsletter",
  newTab = "newTab",
  oldComment = "oldComment",
  oldCommented = "oldCommented",
  oldReward = "oldReward",
  online = "online",
  orderManagement = "orderManagement",
  padlock = "padlock",
  party = "party",
  pause = "pause",
  payment = "payment",
  people = "people",
  perks = "perks",
  person = "person",
  pin = "pin",
  pinFilled = "pinFilled",
  play = "play",
  playVideo = "play-video",
  poll = "poll",
  productsInsights = "products-insights",
  productsMedical = "products-medical",
  productsPerks = "products-perks",
  productsRecognition = "products-recognition",
  productsWellness = "products-wellness",
  question = "question",
  reminder = "reminder",
  removeBookmark = "removeBookmark",
  report = "report",
  restore = "restore",
  rewardActive = "rewardActive",
  rightArrow = "rightArrow",
  seeResults = "seeResults",
  sendExampleSurvey = "sendExampleSurvey",
  share = "share",
  sharedUser = "sharedUser",
  sharedUserSolid = "sharedUserSolid",
  shoppingCart = "shoppingCart",
  simpleFavourite = "simpleFavourite",
  simpleFavouriteOutline = "simpleFavouriteOutline",
  sort = "sort",
  stop = "stop",
  store = "store",
  sell = "sell",
  summaryComments = "summaryComments",
  summaryRecognitions = "summaryRecognitions",
  summaryTrophies = "summaryTrophies",
  tag = "tag",
  trashcan = "trashcan",
  upArrow = "upArrow",
  user = "user",
  userFilled = "userFilled",
  userPlus = "userPlus",
  values = "values",
  video = "video",
  videoFilled = "videoFilled",
  visibility = "visibility",
  vote = "vote",
  voted = "voted",
  infoBlack = "infoBlack",
  history = "history",
  coins = "coins",
  google = "google",
  outlook = "outlook",
  travelBenefit = "travelBenefit",
  travelBenefitFill = "travelBenefitFill",
  pensionTopUp = "pensionTopUp",
  pensionTopUpFill = "pensionTopUpFill",
  gymBenefit = "gymBenefit",
  gymBenefitFill = "gymBenefitFill",
  healthCashPlan = "healthCashPlan",
  healthCashPlanFill = "healthCashPlanFill",
  salaryFinance = "salaryFinance",
  salaryFinanceFill = "salaryFinanceFill",
  payrollGiving = "payrollGiving",
  payrollGivingFill = "payrollGivingFill",
  carBenefit = "carBenefit",
  carBenefitFill = "carBenefitFill",
  circleInformationFill = "circleInformationFill"
}

export default IconTypes
